import { Text } from '@myinterview/component-library';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

interface IProps {
  labelText: string;
  logoSrc: string;
  isLoading: boolean;
}

export const Header: React.FC<IProps> = ({ labelText, logoSrc, isLoading }) => (
  <header className="header-container main-container">
    <div className="header-wrapper flex space-between align-center">
      <Text size="H4">
        {labelText}
      </Text>
      {logoSrc ? (
        <img className="header-wrapper__logo" src={logoSrc} alt="logo" />
      ) : (
        isLoading && <Skeleton className="header-wrapper__logo-loader" />
      )}
    </div>
  </header>
);
